// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__M-Gk_","image":"Header_image__27xGY","name":"Header_name__1atk4","info":"Header_info__2yViB","infoRow":"Header_infoRow__QTLdJ"};